import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { NavigationExtras, Router, RouterLinkWithHref } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject, combineLatest, of, Subscription } from 'rxjs';
import { catchError, debounceTime, map, startWith, switchMap } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { JsonComponent } from 'src/app/core/json/json.component';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { Order, OrdersService, OrderSummary, Notification } from 'src/app/services/api/orders/orders.service';
import { NOTIFICATION_TARGET_SYSTEMS } from 'src/app/utils/Constants';

interface FormObject {
  targetSystem: string;
}

export class FilterMap {

  targetSystem: string[];
  externalOrderId: string[];

  constructor(targetSystem: string[], externalOrderId: string[]) {
    this.targetSystem = targetSystem;
    this.externalOrderId = externalOrderId;
  }

}

@Component({
  selector: 'app-order-details-notifications',
  templateUrl: './order-details-notifications.component.html',
  styleUrls: ['./order-details-notifications.component.scss']
})
export class OrderDetailsNotificationsComponent implements OnInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  displayedColumns: string[] = ['traceId', 'notificationDate', 'targetSystem', 'operationResult', 'dataButton', 'retryButton'];
  dataSource: MatTableDataSource<Notification>;

  _summary: OrderSummary;
  @Input()
  get summary(): any {
    return this._summary;
  }
  set summary(value: any) {
    this._summary = value;
    this.ngOnInit();
  }

  _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    this.ngOnInit();
  }

  _isps: any[];
  @Input()
  get isps(): any {
    return this._isps;
  }
  set isps(value: any) {
    this._isps = value;
    this.ngOnInit();
  }

  jsonRef: MatDialogRef<JsonComponent>;

  searchGroup: FormGroup;
  combos: any;

  private searchSubject = new BehaviorSubject<void>(null);

  private subscriptions = new Subscription();

  appData: any;

  constructor(
    private formBuilder: FormBuilder,
    private ordersService: OrdersService,
    private notificationsService: NotificationsService,
    private router: Router,
    private appService: AppService,
    public dialog: MatDialog) {

  }

  ngOnInit() {

    if (!this.searchGroup) {
      this.searchGroup = this.formBuilder.group({
        targetSystem: this.formBuilder.control(''),
      });

      this.combos = {
        targetSystem: [],
      };

      this.combos.targetSystem = [{ name: 'Cualquiera', value: null }].concat(NOTIFICATION_TARGET_SYSTEMS);

      this.appData = this.appService.settings;
    }

    if (this._summary && !this.dataSource) {
      this.dataSource = new MatTableDataSource();

      this.subscriptions.add(
        this.searchGroup.valueChanges
          .subscribe(
            (data) => {
              let targetSystem;
              if (!data.targetSystem) {
                targetSystem = {
                  filterMap: new FilterMap(NOTIFICATION_TARGET_SYSTEMS.map(targetSystemAux => targetSystemAux.value), [this._summary.externalId])
                };
              }
              else {
                targetSystem = {
                  filterMap: new FilterMap([data.targetSystem], [this._summary.externalId])
                };
              }
              this.ordersService.getOrderNotifications(targetSystem).subscribe(
                (data) => {
                  /*
                  let notifications: Notification[] = [];
                  if (data) {
                    for (const notification of data.notificationMessageDtoList) {
                      
                      if (!notifications.find(auxNotification => auxNotification.traceId === notification.traceId)) {
                        const notificationObject = data.notificationMessageDtoList.filter(auxNotification => auxNotification.traceId === notification.traceId).sort((x, y) => {
                          return moment(x.notificationDate, this.appData.dateFormat)
                            .diff(moment(y.notificationDate, this.appData.dateFormat));
                        })[0];
                        notifications.push(notificationObject);
                      }
                      
                    }
                  }
                  */
                  if (data && data.notificationMessageDtoList) {
                    this.dataSource.data = data.notificationMessageDtoList.sort((x, y) => {
                      return moment(x.notificationDate, this.appData.dateFormat)
                        .diff(moment(y.notificationDate, this.appData.dateFormat));
                    });
                  }
                },
                (error) => {
                  this.notificationsService.showNotification(
                    'No se han podido obtener las notificaciones asociadas a esta orden',
                    NotificationLevel.ERROR);
                },
              )
            }
          ));

      this.targetSystemControl.setValue(this.combos.targetSystem[0].value);
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  retry(row: Notification) {
    this.ordersService.retryNotification(row.notificationId, row).subscribe(
      (data) => {
        this.notificationsService.showNotification(
          'El reintento ha sido correcto',
          NotificationLevel.SUCCESS);
      },
      (error) => {
        this.notificationsService.showNotification(
          'No se ha podido realizar el reintento',
          NotificationLevel.ERROR);
      });
  }

  get targetSystemControl(): FormControl {
    return this.searchGroup.get('targetSystem') as FormControl;
  }

  visualize(notification: Notification) {
    this.jsonRef = this.dialog.open(JsonComponent, {
      data: { title: 'Notificación', json: notification },
      width: '850px'
    });
  }

}
